import React, { useState, useEffect } from 'react';
import { Slide } from 'react-slideshow-image';
import { Icon } from 'semantic-ui-react';
import { functions } from '../../firebase/firebase';
import { httpsCallable } from 'firebase/functions';
import 'react-slideshow-image/dist/styles.css';
import './PromotionsCarousel.css';

const getActivePublicPromotions = httpsCallable(functions, 'getActivePublicPromotions');

const PromotionsCarousel = () => {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPromos = async () => {
      try {
        const result = await getActivePublicPromotions();
        setPromotions(result.data.promotions || []);
      } catch (error) {
        console.error('Could not fetch public promotions:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPromos();
  }, []);

  const properties = {
    duration: 5000,
    transitionDuration: 500,
    infinite: true,
    indicators: false,
    arrows: true,
    pauseOnHover: true,
  };

  if (loading || promotions.length === 0) {
    return null; // Don't render anything if loading or no promotions are available
  }

  return (
    <div>
      <div className="promo-carousel-container">
        <Slide {...properties}>
          {promotions.map((promo) => (
            <div key={promo.id} className="each-promo-slide">
              <div className="promo-content">
                <Icon name="tag" size="large" style={{ marginTop: '-15px', marginLeft: '18px' }} />
                <div className="promo-text">
                  <div className="promo-title">{promo.name}</div>
                  <div className="promo-description">{promo.description}</div>
                </div>
              </div>
            </div>
          ))}
        </Slide>
      </div>
    </div>
  );
};

export default PromotionsCarousel;
